import { VStack } from '@chakra-ui/react';
import React from 'react';
import ModalHeader from "./ModalHeader";

export const EntityModalContent = ({title, close, Body}) => {

    return (
        <VStack w="100%" p="1.5rem" h="100%">
            <ModalHeader title={title} description={""} close={close}/>
            <VStack flex={1} w="100%" align="center" justify="flex-start" overflowY="auto" overflowX="hidden">
                {
                    Body
                }
            </VStack>
        </VStack>
    );
};

export default EntityModalContent;
